export default "__VITE_ASSET__57bbd6f8__"